// component
import Iconify from '../../components/Iconify';
// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const navConfigInd = [
  {
    title: 'Dashboard',
    path: '/',
    icon: getIcon('eva:pie-chart-2-fill'),
    isHideInXs: false,
    positiveAccess: [],
    positiveUserRoles: [],
    negativeUserRoles: [37,38],
    negativeAccess: [863,765,1247],
  },
  {
    title: 'Dashboard',
    path: '/Dashboardapp',
    icon: getIcon('eva:pie-chart-2-fill'),
    isHideInXs: false,
    positiveAccess: [863],
    positiveUserRoles: [],
    negativeUserRoles: [38],
    negativeAccess: [],
  },
  {
    title: 'Dashboard',
    path: '/neterwalaDashboard',
    icon: getIcon('eva:layout-outline'),
    isHideInXs: false,
    positiveAccess: [765],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },

  {
    title: 'Invoice Report',
    path: '/invoiceReport',
    icon: getIcon('eva:layout-outline'),
    isHideInXs: false,
    positiveAccess: [58],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },

  {
    title: 'Dashboard',
    path: '/home',
    icon: getIcon('eva:pie-chart-2-fill'),
    isHideInXs: false,
    positiveAccess: [1247],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  // {
  //   title: 'Add Camera',
  //   path: '/add-client-camera',
  //   icon: getIcon('mdi:camera'),
  //   isHideInXs: false,
  //   positiveAccess: [],
  //   positiveUserRoles: [],
  //   negativeUserRoles: [37],
  //   negativeAccess: [],
  // },
  // {
  //   title: 'Analytics',
  //   path: '/client-analytics',
  //   icon: getIcon('eva:color-palette-outline'),
  //   isHideInXs: false,
  //   positiveAccess: [],
  //   positiveUserRoles: [],
  //   negativeUserRoles: [37],
  //   negativeAccess: [],
  // },

//   {
//     title: 'Video Archives',
//     path: '/video_archives',
//     icon: getIcon('eva:archive-outline'),
//     isHideInXs: false,
//     positiveAccess: [],
//     positiveUserRoles: [],
//     negativeUserRoles: [9,37],
//     negativeAccess: [863,855,917,883],
//   },

  {
    title: 'Settings',
    path: '/creditSettings', 
    icon: getIcon('eva:settings-outline'),
    isHideInXs: false, 
    positiveAccess: [58],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },

  {
    title: 'Price',
    path: '/price', 
    icon:  getIcon('mdi:camera'),
    isHideInXs: false, 
    positiveAccess: [58],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },



  {
    title: 'Invoice Grouping & Time',
    path: '/invoiceGroupingTIime', 
    icon: getIcon('mdi:file-document-outline'),
    isHideInXs: false, 
    positiveAccess: [58],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },

  {
    title:'Audits',
    path: '/audits',
    icon: getIcon('eva:video-off-outline'),
    isHideInXs: false,
    positiveAccess: [],
    positiveUserRoles: [],
    negativeUserRoles: [30,37],
    negativeAccess: [917,883,765],
  },
  
    {
    title: 'Live',
    path: '/livegym',
    icon: getIcon('eva:video-outline'),
    isHideInXs: false,
    positiveAccess: [1262],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },

//   {
//     title: 'Contacts',
//     path: '/client_contacts',
//     icon: getIcon('eva:smartphone-outline'),
//     isHideInXs: false,
//     positiveAccess: [],
//     positiveUserRoles: [],
//     negativeUserRoles: [37],
//     negativeAccess: [863,855,917,883],
//   },
  {
    title: 'Cameras',
    path: '/camerasInfo',
    icon: getIcon('eva:camera-outline'),
    isHideInXs: false,
    positiveAccess: [],
    positiveUserRoles: [],
    negativeUserRoles: [34,38],
    negativeAccess: [1262],
  },
  {
    title: 'Vehicle Tracking Info',
    path: '/VehicleTrackingInfo',
    icon: getIcon('eva:car-outline'),
    isHideInXs: false,
    positiveAccess: [1191,1193],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  {
    title: 'Live',
    path: '/live',
    icon: getIcon('eva:video-outline'),
    isHideInXs: false,
    positiveAccess: [1157],
    positiveUserRoles: [],
    negativeUserRoles: [9,37],
    negativeAccess: [],
  },

  // {
  //   title: 'Live',
  //   path: '/cameras-live',
  //   icon: getIcon('eva:video-outline'),
  //   isHideInXs: false,
  //   positiveAccess: [765],
  //   positiveUserRoles: [],
  //   negativeUserRoles: [],
  //   negativeAccess: [],
  // },
  // {
  //   title: 'Notifications',
  //   path: '/notifications',
  //   icon: getIcon('eva:bell-outline'),
  // isHideInXs: false
  // },


  // {
  //   title: 'Live Audits',
  //   path: 'live-audits',
  //   icon: getIcon('eva:shake-outline'),
  //   isHideInXs: true,
  //   positiveAccess: [],
  //   positiveUserRoles: [],
  //   negativeUserRoles: [],
  //   negativeAccess: [733, 790],
  // },  
  {
    title: 'Security Reports',
    path: 'reports',
    icon: getIcon('eva:book-outline'),
    isHideInXs: true,
    positiveAccess: [733],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  {
    title: 'Employee Reports',
    path: 'reportsinfc',
    icon: getIcon('eva:book-outline'),
    isHideInXs: true,
    positiveAccess: [917],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  {
    title: 'Events Report',
    path: 'jfw-reports',
    icon: getIcon('eva:book-outline'),
    isHideInXs: true,
    positiveAccess: [790],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  {
    title: 'Head Count Inputs',
    path: 'head-count-input',
    icon: getIcon('eva:book-outline'),
    isHideInXs: true,
    positiveAccess: [797,691],
    positiveUserRoles: [30, 2, 7],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  {
    title: 'License Plates',
    path: 'license-plate',
    icon: getIcon('eva:car-outline'),
    isHideInXs: true,
    positiveAccess: [692],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: []
  },
  {
    title: 'Head Count Report',
    path: 'head-count-report',
    icon: getIcon('eva:funnel-outline'),
    isHideInXs: true,
    positiveAccess: [797,691],
    positiveUserRoles: [30, 2, 7],
    negativeUserRoles: [],
    negativeAccess: []
  },
  // {
  //   title: 'Shift Timings',
  //   path: 'shifttime',
  //   icon: getIcon('eva:people-outline'),
  //   isHideInXs: true,
  //   positiveAccess: [],
  //   positiveUserRoles: [],
  //   negativeUserRoles: [],
  //   negativeAccess: [768,765,1193],
  // },
  // {
  //   title: 'Report',
  //   path: '/neterwala',
  //   icon: getIcon('eva:people-outline'),
  //   isHideInXs: false,
  //   positiveAccess: [765],
  //   positiveUserRoles: [],
  //   negativeUserRoles: [],
  //   negativeAccess: [],
  // },
  {
    title: 'Dashboard',
    path: '/DashboardMdPSIT',
    icon: getIcon('eva:pie-chart-2-fill'),
    isHideInXs: false,
    positiveAccess: [37],
    positiveUserRoles: [37],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  {
    title: 'Dashboard',
    path: '/MohiniDashboard',
    icon: getIcon('eva:pie-chart-2-fill'),
    isHideInXs: false,
    positiveAccess: [883],
    positiveUserRoles: [883],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  {
    title: 'Dashboard',
    path: '/DashboardSrmb',
    icon: getIcon('eva:pie-chart-2-fill'),
    isHideInXs: false,
    positiveAccess: [1191],
    positiveUserRoles: [1191],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  {
    title: 'Reports',
    path: '/mdReport',
    icon: getIcon('eva:file-text-outline'),
    isHideInXs: false,
    positiveAccess: [37],
    positiveUserRoles: [37],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  {
    title: 'Shows',
    path: '/addShow',
    icon: getIcon('eva:film-outline'),
    isHideInXs: false,
    positiveAccess: [883],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  {
    title: 'Reports',
    path: '/mohiniReport',
    icon: getIcon('eva:file-text-outline'),
    isHideInXs: false,
    positiveAccess: [883],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
  },
  {
    title: 'Reports',
    path: '/reports', // Adjust the path as needed
    icon: getIcon('eva:file-text-outline'),
    isHideInXs: false, // Adjust visibility as needed
    positiveAccess: [765],
    positiveUserRoles: [],
    negativeUserRoles: [],
    negativeAccess: [],
    children: [
      {
        title: 'Day Wise Report',
        path: '/neterwala', // Adjust the path as needed
        icon: getIcon('eva:people-outline'),
        isHideInXs: false, // Adjust visibility as needed
        positiveAccess: [765],
        positiveUserRoles: [],
        negativeUserRoles: [],
        negativeAccess: [],
      },
      {
        title: 'Monthly Report',
        path: '/neterwalaMonth', // Adjust the path as needed
        icon: getIcon('eva:settings-outline'),
        isHideInXs: false, // Adjust visibility as needed
        positiveAccess: [765],
        positiveUserRoles: [],
        negativeUserRoles: [],
        negativeAccess: [],
      }
    ]
    },

    {
      title: 'Face Registraton',
      path: '/face-list',
      icon: getIcon('eva:people-outline'),
      isHideInXs: false, // Adjust visibility as needed
      positiveAccess: [765],
      positiveUserRoles: [],
      negativeUserRoles: [],
      negativeAccess: [],
      children: [
        {
          title: 'Face Registraton List',
          path: '/face-list', // Adjust the path as needed
          icon: getIcon('eva:people-outline'),
          isHideInXs: false, // Adjust visibility as needed
          positiveAccess: [765],
          positiveUserRoles: [],
          negativeUserRoles: [],
          negativeAccess: [],
        },
        {
          title: 'Add New Face',
          path: '/add-face', // Adjust the path as needed
          icon: getIcon('eva:settings-outline'),
          isHideInXs: false, // Adjust visibility as needed
          positiveAccess: [765],
          positiveUserRoles: [],
          negativeUserRoles: [],
          negativeAccess: [],
        },
        // {
        //   title: 'Entry and Exit Report',
        //   path: '/entry-face-details', // Adjust the path as needed
        //   icon: getIcon('eva:settings-outline'),
        //   isHideInXs: false, // Adjust visibility as needed
        //   positiveAccess: [765],
        //   positiveUserRoles: [],
        //   negativeUserRoles: [],
        //   negativeAccess: [],
        // },
        // {
        //   title: 'Production Report',
        //   path: '/employee-production-details', // Adjust the path as needed
        //   icon: getIcon('eva:settings-outline'),
        //   isHideInXs: false, // Adjust visibility as needed
        //   positiveAccess: [765],
        //   positiveUserRoles: [],
        //   negativeUserRoles: [],
        //   negativeAccess: [],
        // },
         {
          title: 'Attendance Report',
          path: '/employee-attendance-details', // Adjust the path as needed
          icon: getIcon('eva:settings-outline'),
          isHideInXs: false, // Adjust visibility as needed
          positiveAccess: [765],
          positiveUserRoles: [],
          negativeUserRoles: [],
          negativeAccess: [],
        }
      ]
      },

    // {
    //   title: 'Face Register List',
    //   path: '/face-list',
    //   icon: getIcon('eva:people-outline'),
    //   isHideInXs: false,
    //   positiveAccess: [765],
    //   positiveUserRoles: [],
    //   negativeUserRoles: [],
    //   negativeAccess: [],
    // },

    // {
    //   title: 'add-face',
    //   path: '/add-face',
    //   icon: getIcon('eva:people-outline'),
    //   isHideInXs: false,
    //   positiveAccess: [765],
    //   positiveUserRoles: [],
    //   negativeUserRoles: [],
    //   negativeAccess: [],
    // },

    {
      title: 'Shifts',
      path: '/addshifts',
      icon: getIcon('eva:swap-outline'),
      isHideInXs: false,
      positiveAccess: [765],
      positiveUserRoles: [],
      negativeUserRoles: [],
      negativeAccess: [],
    }

];

export default navConfigInd;

